import { render } from "./CheckoutWhiteGetStartedNow.vue?vue&type=template&id=64f9c08e&scoped=true"
import script from "./CheckoutWhiteGetStartedNow.vue?vue&type=script&lang=js"
export * from "./CheckoutWhiteGetStartedNow.vue?vue&type=script&lang=js"

import "./CheckoutWhiteGetStartedNow.vue?vue&type=style&index=0&id=64f9c08e&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64f9c08e"]])

export default __exports__